/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// document.addEventListener('cart:refresh', function(event) {
//   console.log('event',event);
//   var cart = event.detail.cart; // Get the updated content of the cart
//   addFreeProduct(event,cart);
// });

$(document).ready(function(){

  new Swiper(".hero-slider_items-list", {
      slidesPerView: 1,
      spaceBetween: 15,
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
        pagination: {
        el: ".swiper-pagination0",
        clickable: true,
      },
  });
  
  var swiperCollection1 = new Swiper(".coll-list-slider-row", {
    slidesPerView: 1,
    spaceBetween: 15,
    loop: false,
    pagination: {
      el: ".swiper-pagination1",
      clickable: true,
    },
    breakpoints: {
      749: {
        slidesPerView: 2
      },
      1000: {
        slidesPerView: 3
      },
      1450: {
        slidesPerView: 4
      }
    }
  });

  var swiper2 = new Swiper(".image-with-text-slider-blocks", {
    centeredSlides: false,
    loop: false,
    slidesPerView: 1.3,
    initialSlide: 0,
    spaceBetween: 10,
    pagination: {
      el: ".swiper-pagination2",
      clickable: true,
    },
    breakpoints: {
      999: {
        centeredSlides: false,
        spaceBetween: 25,
        // slidesPerView: "auto",
        slidesPerView: 2.1,
        initialSlide: 0,
        loop: true,
      }
    }
  });

  $(".featured-coll-sec-row").each(function () {
    const $slider = $(this);
    const paginationEl = $slider.siblings(".swiper-pagination")[0]; // direct DOM element
    new Swiper(this, {
      slidesPerView: 2,
      spaceBetween: 8,
      loop: true,
      navigation: {
        nextEl: ".featured-coll-sec-swiper-button-next",
        prevEl: ".featured-coll-sec-swiper-button-prev",
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        400: {
          slidesPerView: 2
        },
        1000: {
          slidesPerView: 3,
          spaceBetween: 15
        },
        1300: {
          slidesPerView: 5
        }
      }
    });
  });

  var swiperCollection3 = new Swiper(".featured-posts-list", {
    slidesPerView: 1,
    spaceBetween: 8,
    loop: true,
    navigation: {
        nextEl: ".featured-posts-swiper-button-next",
        prevEl: ".featured-posts-swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination4",
      clickable: true,
    },
    breakpoints: {
      749: {
        slidesPerView: 2        
      },
      1000: {
        slidesPerView: 3,
        spaceBetween: 25
      }
    }
  });

  var swiperCollection5 = new Swiper(".how-to-use-blocks", {
    // enabled: true,
    slidesPerView: 1.1,
    loop: false,
    spaceBetween: 10,
    pagination: {
      el: ".swiper-pagination5",
      clickable: true,
    },
    breakpoints: {
      749: {
        slidesPerView: 2        
      },
      1000: {
        slidesPerView: 3,
        spaceBetween: 25
      }
    }
  });

  // const swiper = new Swiper('.made-width-blocks', {
  //   centeredSlides: true,
  //   loop: true,
  //   speed: 600,
  //   slidesPerView: "auto",
  //   initialSlide: 2,
  //   // spaceBetween: 20,
  //   pagination: {
  //       el: ".swiper-pagination8",
  //       clickable: true,
  //     },
  //   breakpoints: {
  //     999: {
  //       enabled: false
  //     }
  //   },
  // });

  const swiperr = new Swiper(".softer-skin-blocks", {
    slidesPerView: 2.5,
    spaceBetween: 8,
    loop: false,
    pagination: {
      el: ".swiper-pagination14",
      clickable: true,
    },
    breakpoints: {
      1000: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1250: {
        slidesPerView: 3,
        spaceBetween: 25,
      }
    }
  });

  const testimonial_swiperr = new Swiper(".testi-sec-blocks", {
    slidesPerView: 1,
    spaceBetween: 24,
    loop: false,
    pagination: {
      el: ".swiper-pagination-testimonials",
      clickable: true,
    },
    breakpoints: {
      749: {
        slidesPerView: 2.2,
        spaceBetween: 10,
      },
      1300: {
        slidesPerView: 3.2,
        spaceBetween: 15,
      }
    }
  });

  setTimeout(function () {
    var swiperCollection6 = new Swiper(".mini-cart__recommendations-list", {
      slidesPerView: 2,
      spaceBetween: 8,
      loop: false,
      pagination: {
        el: ".swiper-pagination6",
        clickable: true,
      },
      breakpoints: {
        749: {
          slidesPerView: 2        
        }
      }
    });
  }, 2000);
  

  $('body').on('click','.main-article-sec-nav .scroll_link_selector-href', function(){
    var selectr = $(this).attr('data-toscroll');
    console.log('selectr',selectr);
    var mm = $(this).closest('.main-article-sec-inner').find('.main-article-sec-content h2.'+selectr);
    if(mm.length > 0){
      $('html, body').animate({
        scrollTop: mm.offset().top - 150
      }); 
    }    
  });

  $('.product-offer-header').click(function(){
   $(this).toggleClass('active');
   $(this).next().slideToggle();
  });
  $("body").on("click", ".product-offer-code-block", function () {
    var copy_text = $(this).find('.product-offer-copy-code');
    var text = $(this).find('.product-offer-code').text();
    var copy_svg = $(this).find('.product-offer-copy-code').html();
    var $temp = $("<input>");
      
    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
    copy_text.html('Copied');
      
    setTimeout(function () {
      copy_text.html(copy_svg);
    }, 1000);
  });

  $("body").on("click", ".product-toggle-header-item", function () {
    const titleId = $(this).attr("data-title");
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    console.log("titleId",titleId)
    $(this).closest(".product-toggle-header").find(".product-toggle-header-text-item ").each(function () {
      const textId = $(this).attr("data-text");
      console.log("textId",textId)
      if (titleId == textId) {
        $(this).siblings().addClass("hidden");
        $(this).removeClass("hidden");
      }
    })
    $(this).closest(".product-toggle-inner").find(".product-toggle-product-list").each(function (){
      const productId = $(this).attr("data-pro");
      if (productId == titleId) {
        $(this).siblings().addClass("hidden");
        $(this).removeClass("hidden");
      }
    })
  })

// $(document).on('click', '.get-facts-block-btn', function (e) {
//   e.preventDefault();
//   var fileUrl  = $(this).attr('href');
//   var fileName = fileUrl.split('/').pop().split('?')[0];
//   console.log('fileName',fileName);
//   // Fetch the file and download it
//   fetch(fileUrl)
//     .then(function (response) { return response.blob(); })
//     .then(function (blob) {
//       var url = window.URL.createObjectURL(blob);
//       var a = document.createElement('a');
//       a.href = url;
//       a.download = fileName;
//       document.body.appendChild(a);
//       a.click();
//       a.remove();
//       window.URL.revokeObjectURL(url);
//     })
//     .catch(function (err) {
//       console.error('Download failed', err);
//       // Fallback: just open in a new tab
//       window.open(fileUrl, '_blank');
//     });
// });



  $("body").on("click", ".ptpi-info-atc-btn", function () {
    const items = [];
    const val = $(this).attr('data-id');
    items.push({
      quantity: 1,
      id: val
    });
    var data = {items};
    console.log('data',data)
    fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(function(data) {      
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      document.getElementById('mini-cart').open = true;
      $(this).removeAttr("aria-busy");
    }.bind(this)); 
  })

  $("body").on("click","#cart-offers_button", function () {
    $(this).closest("#mini-cart").find("#coupon-offers").attr("open","true");
  })

  $("body").on("click",".cart-offers-condition-title", function(){
   $(this).toggleClass('active');
   $(this).next().slideToggle();
  });

  $("body").on("click",".cart-payment-summary-title", function(){
   $(this).toggleClass('active');
   $(this).next().slideToggle();
  });

  const beforeAfter = document.querySelector('.before-after-media');
  if(beforeAfter){
    const imgAfter = document.querySelector('.before-after-media-before-image');
    const line = document.getElementById('before-after-slider-line');
    const slider = document.getElementById('before-after-slider');
    const beforeText = document.querySelector('.before-after-meida-label');
    const afterText = document.querySelector('.before-after-meida-after-label');

    slider.addEventListener('input', () => {
      const value = slider.value;
      line.style.left = `${slider.value}%`;   
      imgAfter.style.clipPath = `inset(0px 0px 0px ${slider.value}%)`;
    });

    // Reset on double-click
    slider.addEventListener('dblclick', () => {
      slider.value = 50;
      line.style.left = '50%';
      imgAfter.style.clipPath = 'inset(0px 0px 0px 50%';
    });
  }  

  

  if ($('body').hasClass('template-product')) {
    let lastScrollTop = 0;
    $(window).on('scroll', function () {
      let currentScroll = $(this).scrollTop();
      if (currentScroll < lastScrollTop && currentScroll > 100) {
        // Scroll UP
        $('.template-product .shopify-section--search-bar-mobile').addClass('show');
      } else {
        // Scroll DOWN
        $('.template-product .shopify-section--search-bar-mobile').removeClass('show');
      }
      lastScrollTop = currentScroll;
    });
  }  

});

document.addEventListener('cart:refresh', function(event) {
  console.log('event',event);
  // var cart = event.detail.cart; // Get the updated content of the cart
  // addFreeProduct(event,cart);
});

$(document).ready(function(){
  // CART DRAWER DEFAULT OFFER
  function getCartCodes(){
    return $.getJSON('/cart.js').then(cart =>
      (cart.discount_codes || []).filter(d => d.applicable).map(d => d.code)
    );
  }

  function customerHasTag(tag){
    if(!tag) return true;
    var tags = ($('#mini-cart').attr('data-customer-tags') || '').split(',');
    return tags.indexOf(tag.toLowerCase()) !== -1;
  }

  function requiredTagForCode(code){
    var tag = '';
    code = (code || '').toUpperCase();
    $('.cart-coupon_offer_item-coupon-btn[data-required-tag], .restricted-code-map').each(function(){
      var c = ($(this).attr('coupon') || $(this).attr('data-code') || '').toUpperCase();
      if(c === code){
        tag = $(this).attr('data-required-tag');
      }
    });
    return tag;
  }

  function applied_code(discountCodeValue, _this, sectionId){
    var requiredTag = requiredTagForCode(discountCodeValue);
    if(requiredTag && !customerHasTag(requiredTag)){
      $(_this).removeAttr('disabled').removeAttr('loading').removeClass('loading');
      $('.cart-offer-coupon_applied-message').append('<div class="applied_code_error text--xsmall">This code isn\'t available for your account</div>');
      setTimeout(function(){ $('.applied_code_error').remove(); }, 2000);
      return;
    }

    getCartCodes().then(existingCodes => {
      if (existingCodes.some(c => c.toLowerCase() === discountCodeValue.toLowerCase())) {
        $(_this).removeAttr('disabled').removeAttr('loading').removeClass('loading');
        return;
      }
      return fetch(`${window.themeVariables.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          discount: [...existingCodes, discountCodeValue].join(','),
          sections: [sectionId]
        })
      }).then(res => res.json());
    }).then(data => {
      if (!data) return;

      if (data.discount_codes.find(d => d.code === discountCodeValue && d.applicable === false)) {
        $(_this).removeAttr('disabled').removeAttr('loading').removeClass('loading');
        $('.cart-offer-coupon_applied-message').append(`<div id="applied_code_error" class="applied_code_error text--xsmall">This discount code cannot be applied to your cart</div>`);
        setTimeout(function(){ $('.applied_code_error').remove(); }, 2000);
        return;
      }

      $.getJSON('/cart.js', function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { cart }
        }));
      });
    }).catch(() => {
     $(_this).removeAttr('disabled').removeAttr('loading').removeClass('loading');
   });
  }

  $('body').on('keyup','.cart-offer-coupon_input-field, .cart-coupon_offer-input_field', function(){
    if($(this).val() != ''){
     $(this).closest('.cart-offer-coupon_input, .cart-coupon_offer-input').find('.cart-offer-coupon_apply-button, .cart-coupon_offer-input_submit').addClass('active'); 
    }else{
     $(this).closest('.cart-offer-coupon_input, .cart-coupon_offer-input').find('.cart-offer-coupon_apply-button, .cart-coupon_offer-input_submit').removeClass('active');
    }    
  });

   // Apply Offer drawer: manual code input
  $('body').on('click', '.cart-coupon_offer-input_submit.active', function(){
    console.log('ggggg');
    var _this = this;
    var $input = $(this).closest('.cart-coupon_offer-input').find('.cart-coupon_offer-input_field');
    var discountCodeValue = $.trim($input.val());
    var sectionId = $(_this).closest('cart-drawer').attr('section');

    if (!discountCodeValue || $(_this).is('[loading]')) return;

    $(_this).attr('disabled', 'disabled').attr('loading', 'loading');
    $('#applied_code_error').remove();
    applied_code(discountCodeValue, _this, sectionId);
  });

  // Enter key in that input
  $('body').on('keydown', '.cart-coupon_offer-input_field', function(e){
    if (e.key !== 'Enter') return;
    e.preventDefault();
    $(this).closest('.cart-coupon_offer-input').find('.cart-coupon_offer-input_submit').trigger('click');
  });

  $('body').on('click','.cart-offer-coupon_apply-button.active', function(){
    console.log('dddf');
    var _this  = this;
    var discountCodeValue = $(this).closest('.cart-offer-coupon_input').find('.cart-offer-coupon_input-field').val();
    var sectionId = $(_this).closest('cart-drawer').attr('section');
    if(discountCodeValue == ''){
      _this.closest('.cart-offer-coupon_input').after('<p class="offer_input_err">Please enter any code above.</p>');
      return;
    }
    $(_this).attr("disabled","disabled");
    $(_this).attr("loading","loading");

    $('#applied_code_error').remove();
    applied_code(discountCodeValue, _this, sectionId);
  });

  $('body').on('click','.cart-coupon_offer_item-coupon-btn', function(){
    var _this  = this;
    var discountCodeValue = $(this).attr('coupon');
    var sectionId = $(_this).closest('cart-drawer').attr('section');
    $(_this).attr("disabled","disabled");
    $(_this).attr("loading","loading");

    $('#applied_code_error').remove();
    applied_code(discountCodeValue, _this, sectionId);
  });
  
  $('body').on('click','[data-removecode]', function(){
    var discountCodeValue = $(this).closest('.applied_coupon-item').attr('data-discount-code');
    var $chip = $(this).closest('.applied_coupon-item');
   var discountCodeValue = $chip.attr('data-discount-code');
   if ($chip.hasClass('is-removing')) return;
   $chip.addClass('is-removing');

    getCartCodes().then(codes => {
      const remaining = codes.filter(c => c.toLowerCase() !== discountCodeValue.toLowerCase());
      return $.ajax({
        url: '/cart/update.js',
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ discount: remaining.join(',') })
      });
    }).then(() => {
      $.getJSON('/cart.js', function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { cart }
        }));
      });
    }).catch(() => {
     $chip.removeClass('is-removing');
   });
  });

  // FREE SHIPPING CODE → show "Free", adjust totals, add chip
  function syncShippingCode(){
    const $drawer = $('#mini-cart');
    const shippingCodes = String($drawer.data('free-shipping-codes') || '').split(',').filter(Boolean);
    if (!shippingCodes.length || !$drawer.find('.cart-payment-summary_shipping').length) return;

    getCartCodes().then(codes => {
      const code = codes.find(c => shippingCodes.includes(c.toLowerCase()));
      if (!code) return;

      $drawer.find('.cart-payment-summary_shipping .cart-payment-summary_item-price').addClass('free').text('Free');
      $drawer.find('[data-free-shipping-total]').each(function(){
        $(this).text($(this).data('free-shipping-total'));
      });
      $drawer.find('.mini-cart-footer-shipping').removeAttr('hidden');

      const chip = `
        <div class="applied_coupon-item" data-discount-code="${code}">
          ${$('#coupon-chip-icon').html()}
          <span class="af_coupon_text af_coupon_code">${code}</span>
          <div class="removeAfTag remove_selected_coupon" data-removecode>x</div>
        </div>`;

      $drawer.find('.applied_couponWrapper, .applied_couponWrapperr').each(function(){
        if ($(this).find(`[data-discount-code="${code}"]`).length) return;
        $(this).removeAttr('hidden').prepend(chip);
      });
    });
  }

  syncShippingCode();
  const miniCartEl = document.getElementById('mini-cart');
  if (miniCartEl) new MutationObserver(syncShippingCode).observe(miniCartEl, { childList: true });

  $("body").on("click",".gfmma-modal-btn", function() {
    $('html').addClass('lock-all');
    $(this).closest(".get-facts-media-content-wrapper").find(".get-facts-media-modal-wrap").attr("open", "");
  })
  $("body").on("click", ".get-facts-media-modal-button-close, .get-facts-media-modal-overlay", function (){
    $('html').removeClass('lock-all');
    $(this).closest('.get-facts-media-content-wrapper').find('.get-facts-media-modal-wrap').removeAttr('open', '');
  })

  $("body").on("click",".get-facts-block-btn", function() {
    $('html').addClass('lock-all');
    const btnId = $(this).data('id');
    console.log('btnId',btnId);
    $(".get-facts-block-modal-wrap").each(function() {
      const modalId = $(this).data("modal");
      console.log('modalId',modalId);
      if(btnId == modalId) {
        $(this).attr("open","");
      }
    })
  })
  $("body").on("click",".get-facts-block-modal-button-close, .get-facts-block-modal-overlay", function() {
    $('html').removeClass('lock-all');
    const btnId = $(this).data('id');
    console.log('btnId',btnId);
    $(".get-facts-block-modal-wrap").removeAttr('open', '');
  })

  $('.cart-more-less-btn').map(function(){
    $(this).find('#review-read').click(function(){
      $(this).toggleClass("active")
      $(this).text($(this).text() == 'Read more' ? 'Read less' : 'Read more');
      $(this).parent().parent('.review-slider-item-inner').toggleClass('cls-added');
    })
  });

  $("body").on("click",".cart-more-less-btn", function() {
    $(this).toggleClass("active");
    $(this).text($(this).text() == '+ More' ? '- Hide' : '+ More');
    $(this).closest(".cart-coupon-offer-item-wrp").find(".cart-coupon-more-info").toggleClass('active');
  })

  $("body").on("click", ".faq__item .collapsible-toggle", function (e) {
    e.preventDefault();
    var activeItem = $(this).closest(".faq__item");
    var currentDropdown = activeItem.find(".collapsible");
    // Other items close
    $(".faq__item").not(activeItem).removeClass("active");
    $(".faq__item").not(activeItem).find(".collapsible").removeAttr("open");
    // Current toggle
    activeItem.toggleClass("active");
    if (activeItem.hasClass("active")) {
      currentDropdown.attr("open", true);
    } else {
      currentDropdown.removeAttr("open");
    }
  });

  // BUNDLE PAGE
  var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
  function activecheck(addedcnt, bundle_price, bundle_compare_price){
    var bundleItemCount = parseInt($('.bundle-product-list').attr('data-bundleitemcnt'));
    var bundleamount = parseInt($('.bundle-preview_cart-prices').attr('data-off-price')) * 100;
    var isFull = addedcnt == bundleItemCount;
    var comparePrice = isFull ? bundle_price : bundle_compare_price;
    var saveAmount = comparePrice - bundleamount;

    if(isFull){
      $('.quantity-selector .quantity-selector__button:last-child').attr('disabled','disabled');
      $('.bundle-product-item__cta:not(.added)').attr('disabled','disabled');
      $('.bundle-add_to_cart_button').html(`<span class="loader-button__text"><span class="product-item__cta-text">Add To Cart</span></span><span class="loader-button__loader"><div class="spinner"><svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle></svg></div></span>`).addClass('readytoadd');
    }else{
      $('.quantity-selector .quantity-selector__button:last-child').removeAttr('disabled');
      $('.bundle-product-item__cta:not(.added)').removeAttr('disabled');
      $('.bundle-add_to_cart_button').html('Add To Cart').removeClass('readytoadd');
    }

    $('.bundle-preview_cart-prices .price--compare').html(formatMoney(comparePrice, currencyFormat));

    if(saveAmount > 0){
      $('.bundle-preview_cart-save').html(`(Save ${formatMoney(saveAmount, currencyFormat)})`).show();
    }else{
      $('.bundle-preview_cart-save').hide();
    }

    if(addedcnt > 0){
      $('.bundle-preview_cart').show();
    }else{
      $('.bundle-preview_cart').hide();
    }
  }

  var addedcnt = 0;
  var bundle_price = 0;
  var bundle_compare_price = 0;
  $('body').on('click', '.bundle-product-item__cta', function(e){
    e.preventDefault();
    // var currentIndex = addedcnt; // 0-based index
    var productt = $(this).closest('.product-item');
    var emptySlot = $('.bundle-preview-cart-item').filter(function(){
      return $(this).find('.bundle-preview_cart-item-iner').length === 0;
    }).first();
    addedcnt += 1;
    bundle_compare_price += parseInt($(this).closest('.product-item').attr('data-product-compareprice'));
    bundle_price += parseInt($(this).closest('.product-item').attr('data-product-price'));
    var prevval = $(this).closest('.bundle-product-item__cta-wrapper').find('.quantity-selector input').val();
    $(this).closest('.bundle-product-item__cta-wrapper').find('.quantity-selector input').val(parseInt(prevval) + 1);
    console.log(bundle_compare_price)
    activecheck(addedcnt,bundle_price,bundle_compare_price);
    $(this).attr("disabled","disabled").addClass('added');
    productt.find('.bundle-product-item__cta').attr("disabled","disabled").addClass('added');
    var featuredimage = $(this).closest('.product-item').attr('data-featuredimage');    
    var itembox = `<div class="bundle-preview_cart-item-iner"
      data-vid="${$(this).closest('.product-item').attr('data-variant-id')}"
      data-sku="${$(this).closest('.product-item').attr('data-variant-sku')}"
      data-pid="${$(this).closest('.product-item').attr('data-product-id')}"
      data-price="${$(this).closest('.product-item').attr('data-product-price')}"
      data-title="${$(this).closest('.product-item').attr('data-product-name')}"
      data-compare_price="${parseInt($(this).closest('.product-item').attr('data-product-compareprice'))}"
      data-qty="1"
    >
      <img src="${featuredimage}" loading="lazy" width="70" height="70" alt="">
    </div>`;
    // Target specific box using index
    if(emptySlot.length){
      emptySlot.append(itembox);
      emptySlot.find('.bundle-preview_car-item-remove').addClass('active');
    }
    // $('.bundle-preview-cart-item').eq(currentIndex).find('.bundle-preview_car-item-remove').addClass('active');
    $(this).html(`Added`);
    productt.find('.bundle-product-item__cta').html(`Added`);
    // $(this).hide().closest('.bundle-product-item__cta-wrapper').find('.quantity-selector').show();
    $(this).siblings('.bunle-product-item-remove').addClass('active');
    productt.find('.bundle-product-item__cta').siblings('.bunle-product-item-remove').addClass('active');
  })

  $('body').on('click', '.bunle-product-item-remove', function(e){
    e.preventDefault();
    var product = $(this).closest('.product-item');
    var variantId = product.attr('data-variant-id');
    var previewItem = $('.bundle-preview_cart-item-iner[data-vid="'+variantId+'"]');
    if(!previewItem.length) return;
    addedcnt -= 1;
    bundle_price -= parseInt(product.attr('data-product-price'));
    bundle_compare_price -= parseInt(product.attr('data-product-compareprice'));
    activecheck(addedcnt, bundle_price, bundle_compare_price);
    previewItem.parent('.bundle-preview-cart-item').find('.bundle-preview_car-item-remove').removeClass('active');
    previewItem.remove();
    product.find('.quantity-selector input').val(0);
    product.find('.bundle-product-item__cta').removeAttr('disabled').removeClass('added').html('Add To Box');
    // $(this).removeClass('active'); 
    product.find('.bundle-product-item__cta').siblings('.bunle-product-item-remove').removeClass('active');  
  });

  // BUNDLE PRODUCT REMOVE
  $('body').on('click','.bundle-preview_car-item-remove.active', function(){
    addedcnt = addedcnt - $(this).closest('.bundle-preview-cart-item').find('.bundle-preview_cart-item-iner').attr('data-qty');
    console.log(addedcnt,'addedcnt');
    bundle_compare_price = bundle_compare_price - (parseInt($(this).closest('.bundle-preview-cart-item').find('.bundle-preview_cart-item-iner').attr('data-compare_price')) * parseInt($(this).closest('.bundle-preview-cart-item').find('.bundle-preview_cart-item-iner').attr('data-qty')));
    console.log(bundle_compare_price,'bundle_compare_price');
    bundle_price = bundle_price - (parseInt($(this).closest('.bundle-preview-cart-item').find('.bundle-preview_cart-item-iner').attr('data-price')) * parseInt($(this).closest('.bundle-preview-cart-item').find('.bundle-preview_cart-item-iner').attr('data-qty')));   
    console.log(bundle_price,'bundle_price');
    activecheck(addedcnt,bundle_price,bundle_compare_price);
    var variantIdd = $(this).closest('.bundle-preview-cart-item').find('.bundle-preview_cart-item-iner').attr('data-vid');
    var removeProduct = $(`.product-item[data-variant-id="${variantIdd}"]`); 
    // $(`.product-item[data-variant-id="${$(this).closest('.bundle-preview-cart-item').find('.bundle-preview_cart-item-iner').attr('data-vid')}"]`).find('.quantity-selector').hide().find('input').val(0);
    removeProduct.find('.quantity-selector').hide().find('input').val(0);
    // $(`.product-item[data-variant-id="${$(this).closest('.bundle-preview-cart-item').find('.bundle-preview_cart-item-iner').attr('data-vid')}"]`).find('.bundle-product-item__cta').removeAttr("disabled").removeClass('added').show();
    removeProduct.find('.bundle-product-item__cta').removeAttr("disabled").removeClass('added').show().html('Add To Box');
    // $(`.product-item[data-variant-id="${$(this).closest('.bundle-preview-cart-item').find('.bundle-preview_cart-item-iner').attr('data-vid')}"]`).find('.bundle-product-item__cta').siblings('.bunle-product-item-remove').removeClass('active');
    removeProduct.find('.bundle-product-item__cta').siblings('.bunle-product-item-remove').removeClass('active');
    $(this).closest('.bundle-preview-cart-item').find('.bundle-preview_cart-item-iner').remove();
    $(this).removeClass('active');
  })

  document.addEventListener('cart:updated', function(event) {
    var cart = event.detail.cart; // Get the updated content of the cart
    // var packging_item = window.customthemeVariables.cartsettings.packging_item;
    // var haspackateitem = cart.items.filter(function(item){
    //   return item.id == packging_item['variants'][0].id
    // });
    // console.log(haspackateitem);
    // if(cart['item_count'] == 1 && haspackateitem.length > 0){
    //   var updateData = {};        
    //   updateData[packging_item['variants'][0].id] = 0;
    //   $.ajax({
    //     type: 'POST',
    //     url: '/cart/update.js',
    //     data: {
    //       updates: updateData
    //     },
    //     dataType: 'json',
    //     async: true,
    //     error: function (jqXHR, textStatus, errorThrown) {
    //       console.log('error')            
    //     },
    //     success: function(data) {   
    //       console.log('success')
    //       document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
    //         bubbles: true
    //       }));
    //     }
        
    //   });
    // }
  });

  console.log('indindind');

  $('body').on('click','.bundle-add_to_cart_button.readytoadd', function(){
    var $btn  = $(this);
    var $main = $btn.closest('.bundle-preview_cart-main');
    
    $btn.attr('aria-busy', true).attr('disabled', 'disabled');

    var val = $main.find('.bundle-preview_cart-buttons').attr('data-id');
    var qty = 1;

    // Build inline properties from the selected products (Item 1..N)
    var properties = {};
    properties['_bundle'] = 'true';
    properties['_bundle_id'] = Date.now().toString();
    properties['_selected_total'] = bundle_price; 

    // API products payload
    var apiProducts = [];
    var varqtylist = [];    

    $main.find('.bundle-preview_cart-item-iner:not(.hasblank)').each(function (i,e) {
      var slot = i + 1;
      var vid     = $(this).attr('data-vid');
      var pid     = $(this).attr('data-pid');
      var itemQty = parseInt($(this).attr('data-qty'), 10) || 1;
      var title   = $(this).attr('data-title');
      var vsku   = $(this).attr('data-sku');

      if (!title) {
        title = $('.product-item[data-variant-id="' + vid + '"]').find('.bundle-product-item__title').first().text().trim();
      }
      if (!title) { title = 'Selected item'; }
      properties['_Item_'+slot+'_name'] = itemQty+' x ' + title;
      // properties['Item '+ slot + ' SKU'] = vsku;
      const components = [
        {
          variantId: 123456789,
          qty: 2
        },
        {
          variantId: 987654321,
          qty: 1
        },
        {
          variantId: 456789123,
          qty: 3
        }
      ];

      varqtylist.push({
        variantId: vid,
        qty: itemQty
      })
      
      apiProducts.push({
        product_id: pid,
        variant_id: vid,
        quantity: itemQty
      });
    });

    var apiData = {
      action: 1,
      products: apiProducts,
      actual_price: bundle_price,
      final_price: parseInt($('.bundle-preview_cart-prices').attr('data-off-price')) * 100
    };

    console.log(apiData);
    const componentVariants = varqtylist
    .map(item => `${item.variantId}:${item.qty}`)
    .join(', ');
    console.log(componentVariants);

    fetch('https://dev.d2cbox.com/shopify/api/v1/bundle/', {
      method: 'POST',
      body: JSON.stringify(apiData),
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'b81eedcba1314dd9a10dc478545b5c2e'
      }
    })
    .then(function (response) { return response.json(); })
    .then(function (res) {
      // Adjust to the actual key in your API response
      console.log(res);
      properties['_page_bundle_id'] = res.bundle_id;
      properties['_Details'] = componentVariants;
      properties['Bundle item'] = 'Yes';

      var data = {
        items: [{
          id: val,
          quantity: qty,
          properties: properties
        }]
      };
    
      console.log('data',data)

      return fetch('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
    })
    .then(function (response) { return response.json(); })
    .then(function () {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.getElementById('mini-cart').open = true;

      $('.bundle-product-item__cta-wrapper').find('.quantity-selector').hide().find('.quantity-selector__input').val(0);
      $('.bundle-preview_cart-items .bundle-preview_cart-item-iner').remove();
      $('.bundle-product-item__cta').removeAttr('disabled').removeClass('added').html('Add To Box');
      $('.bunle-product-item-remove').removeClass('active');

      addedcnt = 0;
      bundle_price = 0;
      activecheck(0, bundle_price, bundle_compare_price);
    })
    .catch(function (err) {
      console.error('Bundle add failed', err);
    })
    .finally(function () {
      $btn.removeAttr('aria-busy').removeAttr('disabled');
    });
  });

    
  //   fetch('/cart/add.js', {
  //     method: 'POST',
  //     body: JSON.stringify(data),
  //     credentials: 'same-origin',
  //     headers: {
  //       'Content-Type': 'application/json; charset=UTF-8',
  //       'X-Requested-With': 'XMLHttpRequest'
  //     }
  //   })
  //   .then(response => response.json())
  //   .then(function(data) { 
  //     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
  //       bubbles: true
  //     }));
  //     document.getElementById('mini-cart').open = true;
  //     // onCheckoutClick(this);
  //     $(this).removeAttr("aria-busy");
  //     $(this).removeAttr("disabled");
  //     $('.bundle-product-item__cta-wrapper').find('.quantity-selector').hide().find('.quantity-selector__input').val(0);
  //     // $('.bundle-product-item__cta-wrapper').find('.bundle-product-item__cta').show();
  //     $('.bundle-preview_cart-items .bundle-preview_cart-item-iner').remove();
  //     $('.bundle-product-item__cta').removeAttr("disabled").removeClass('added');
  //     $('.bundle-product-item__cta').html('Add To Box');
  //     $('.bunle-product-item-remove').removeClass('active');
  //     addedcnt = 0;
  //     bundle_price = 0;
  //     activecheck(0,bundle_price,bundle_compare_price);
  //    }.bind(this));
  // })

  // BUNDLE PAGE FLIP PRODUCT CARDS
  if (window.matchMedia('(min-width: 1000px)').matches) {
    $('body').on('click','.bppi-info-wrap', function () {
      $(this).addClass('flipped');
      $(this).closest('.bundle-page-pro-item').addClass('active');
    })
    $('body').on('click','.bppi-back-element-close', function () {
      $(this).closest('.bundle-page-pro-item').find('.bppi-info-wrap').removeClass('flipped');
      $(this).closest('.bundle-page-pro-item').removeClass('active');
    })
  }
  if (window.matchMedia('(max-width: 999px)').matches) {
    $('body').on('click','.bppi-info-wrap', function () {
      $('html').addClass('lock-all');
      $(this).closest('.bundle-page-pro-item-inr').find('.pro-card-back-element').attr('open','');
    })
    $('body').on('click','.pro-card-back-element-close, .pro-card-back-element-overlay', function () {
      $('html').removeClass('lock-all');
      $(this).closest('.pro-card-back-element').removeAttr('open');
    })
  }

  // REMOVE SEARCH INPUT ON CLICK
  $(document).on("click",".pre-search-input-clear", function (){
    const $wrapper = $(this).closest(".predictive-search-secondary");
    const searchWrap = $wrapper.find(".predictive-search__results");
    const searchFooter = $wrapper.find(".drawer__footer");
    console.log('searchFooter',searchFooter);
    searchWrap.attr("hidden", "hidden");
    searchFooter.attr("hidden", "hidden");
    $(this).removeClass("active");
    $(this).siblings('.predictive-search__input').val('');
    $("html").removeClass("lock-all");
  })

  $('body').on('click','.line-item.bundle-box .line-item-view-boxes', function() {
    $(this).toggleClass('active');
    $(this).next('.product-item-meta__property').slideToggle();
  })

  $('body').on('click','.pre_search_bar', function (e) {
    e.preventDefault();
    $(this).closest('.predictive-search-secondary').find('.predictive-search__menu-list').removeAttr('hidden');
  })
  $(document).on('click', function (e) {
      if (
          !$(e.target).closest('.pre_search_bar').length &&
          !$(e.target).closest('.predictive-search__menu-list').length
      ) {
          $('.predictive-search__menu-list').attr('hidden', true);
      }
  });

  $('body').on('click', '.product-meta-accordion-title', function () {
    $(this).toggleClass('active');
    $(this).next('.product-meta-accordion-text').slideToggle();
  })

})

function isPartiallyInView($el) {
  var elementTop = $el.offset().top;
  var elementBottom = elementTop + $el.outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  // Returns true if any part of the element is visible
  return elementBottom > viewportTop && elementTop < viewportBottom;
}

function isFullyOutOfView($el) {
  var elementTop = $el.offset().top;
  var elementBottom = elementTop + $el.outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  // Returns true if element is entirely above or below the viewport
  return elementBottom <= viewportTop || elementTop >= viewportBottom;
}

function counterFun() {
  const counterElement = $('.clinically-proven-inner');
  if (counterElement.length) {
    if (isPartiallyInView(counterElement)) {
      $('.cpb-block-circle').each(function () {
        var $this = $(this);
        let countTo = parseInt($this.attr('data-count'), 10);
        if (!$this.hasClass('counted')) {
          $this.addClass('counted');
          $({ countNum: 0 }).animate(
            { countNum: countTo },
            {
              duration: 2000,
              easing: 'swing',
              step: function () {
                let current = Math.floor(this.countNum);
                $this.find('.cpb-block-count').text(current);
                $this.css('--value', current);
              },
              complete: function () {
                $this.find('.cpb-block-count').text(countTo);
                $this.css('--value', countTo);
              }
            }
          );
        }
      })  
    } else if (isFullyOutOfView(counterElement)) {
      // Reset only when fully out of view
      $('.cpb-block-circle').each(function () {
        $(this).removeClass('counted').find('.cpb-block-count').text('0');
      });
    }
  }

  const counterElement2 = $('.results-section-inner');
  if(counterElement2.length) {
    if (isPartiallyInView(counterElement2)) {
      $('.results-section-block-number').each(function () {
        let $count = $(this).find('.count');
        let countTo = parseInt($count.attr('data-count'), 10);
        if (!$(this).hasClass('counted')) {
          $(this).addClass('counted');
          $({ countNum: 0 }).animate(
            { countNum: countTo },
            {
              duration: 2000,
              easing: 'swing',
              step: function () {
                $count.text(Math.floor(this.countNum));
              },
              complete: function () {
                $count.text(countTo)
              }
            }
          )
        }
      })
    }else if (isFullyOutOfView(counterElement2)) {
      // Reset only when fully out of view
      $('.results-section-block-number').each(function () {
        $(this).removeClass('counted').find('.count').text('0');
      });
    }
  }
}
$(window).on('scroll resize', counterFun);
$(document).ready(counterFun);


$(document).ready(function () {

  var observer = new IntersectionObserver(function(entries){

    entries.forEach(function(entry){

      if(entry.isIntersecting){

        var $items = $(entry.target).find('.reveal-item');

        $items.each(function(index){

          var $el = $(this);

          setTimeout(function(){
            $el.addClass('is-visible');
          }, index * 150); // 👈 150ms delay per item

        });

        observer.unobserve(entry.target);

      }

    });

  }, { threshold: 0.2 });

  $('.reveal-parent').each(function(){
    observer.observe(this);
  });

});

// ============================================================

// (function ($) {
//   'use strict';

//   const NS = '.trackOrder';
//   // const ENDPOINT = 'https://joyun-trackorder.sagar-shopify.workers.dev';
//   const ENDPOINT = 'https://joyun-track-order.chintan-chovatiya.workers.dev';

//   const esc = s => $('<div>').text(s == null ? '' : s).html();

//   // "2026-08-11 16:50:44" -> Date (the "T" makes it parse in Safari too)
//   const toDate = str => (str ? new Date(String(str).replace(' ', 'T')) : null);

//   const fmtTime = str => {
//     const d = toDate(str);
//     return d && !isNaN(d) ? d.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' }) : (str || '');
//   };

//   const fmtDay = str => {
//     const d = toDate(str);
//     return d && !isNaN(d)
//       ? d.toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })
//       : (str || '');
//   };

//   // "Delivered - Delivered to consignee - Code Verified delivery"
//   // -> headline: "Delivered", detail: "Delivered to consignee - Code Verified delivery"
//   const splitStatus = str => {
//     const [headline, ...rest] = String(str || '').split(' - ');
//     return { headline, detail: rest.join(' - ') };
//   };

//   const banner = (type, msg) =>
//     `<div class="order-tracker__banner banner banner--${type}"><p class="banner__content">${esc(msg)}</p></div>`;

//   function render(data) {
//     const activities = data.activities || [];
//     const latest = activities[0] || {};
//     const isDelivered = String(data.status || '').toLowerCase() === 'delivered';

//     // Group scans by day (API already returns newest first)
//     const groups = [];
//     const byDay = {};
//     activities.forEach(a => {
//       const day = fmtDay(a.date);
//       if (!byDay[day]) {
//         byDay[day] = { day, items: [] };
//         groups.push(byDay[day]);
//       }
//       byDay[day].items.push(a);
//     });

//     const timeline = groups.map(group => {
//       const items = group.items.map(a => {
//         const { headline, detail } = splitStatus(a.status);
//         return `
//           <li class="order-tracker__scan">
//             <div class="order-tracker__scan--wrapper">
//               <span class="order-tracker__scan-time">${esc(fmtTime(a.date))}</span>
//               <span class="order-tracker__scan-headline">${esc(headline)}</span>
//               ${detail ? `<span class="order-tracker__scan-detail">${esc(detail)}</span>` : ''}
//               ${a.location ? `<span class="order-tracker__scan-sub">${esc(a.location)}</span>` : ''}
//             </div>
//           </li>`;
//       }).join('');

//       return `
//         <div class="order-tracker__day-group">
//           <p class="order-tracker__day">${esc(group.day)}</p>
//           <ul class="order-tracker__timeline">${items}</ul>
//         </div>`;
//     }).join('');

//     const emptyNote = data.awb
//       ? 'Tracking updates will appear once the courier scans your package.'
//       : 'Your order is being prepared for dispatch.';

//     return `
//       <div class="order-tracker__summary">
//         <p class="order-tracker__status-label text--small">Order ${esc(data.order_id)} · Current status</p>
//         <p class="order-tracker__status heading h5">${esc(data.status)}</p>
//         ${latest.status ? `<p class="order-tracker__summary-line">${esc(splitStatus(latest.status).detail || latest.status)}</p>` : ''}
//         ${latest.location ? `<p class="order-tracker__summary-line"><span class="order-tracker__summary-line-label">Location:</span> ${esc(latest.location)}</p>` : ''}
//         ${data.courier ? `<p class="order-tracker__summary-line"><span class="order-tracker__summary-line-label">Courier:</span> ${esc(data.courier)}${data.awb ? ` · AWB ${esc(data.awb)}` : ''}</p>` : ''}
//         ${isDelivered && latest.date
//           ? `<p class="order-tracker__edd"><span class="order-tracker__summary-line-label">Delivered on:</span> ${esc(fmtDay(latest.date))}</p>`
//           : data.etd ? `<p class="order-tracker__edd"><span class="order-tracker__summary-line-label">Expected delivery:</span> ${esc(fmtDay(data.etd))}</p>` : ''}
//         ${!activities.length ? `<p class="order-tracker__summary-line">${esc(emptyNote)}</p>` : ''}
//       </div>
//       ${timeline ? `<div class="order-tracker__timeline-wrap">${timeline}</div>` : ''}`;
//   }

//   $(document)
//     .off(NS)
//     .on('submit' + NS, '[data-track-form]', function (e) {
//       e.preventDefault();

//       const $form = $(this);
//       const $root = $form.closest('[data-track-order]');
//       const $result = $root.find('[data-track-result]');
//       const $submit = $form.find('[type="submit"]');
//       const submitText = $submit.data('text') || $submit.text();
//       const orderId = $.trim($form.find('[name="order_id"]').val()).replace(/^#/, '');

//       $submit.data('text', submitText);
//       $result.removeClass('error').empty();

//       if (!orderId) {
//         $result.addClass('error').html(banner('error', 'Please enter your order number.'));
//         return;
//       }

//       $submit.prop('disabled', true).text('Tracking…');

//       $.ajax({
//         url: ENDPOINT,
//         method: 'POST',
//         contentType: 'application/json',
//         dataType: 'json',
//         data: JSON.stringify({ order_id: orderId })
//       })
//         .done(function (data) {
//           $result.html(render(data));
//           $('html, body').animate({ scrollTop: $result.offset().top - 90 }, 400);
//         })
//         .fail(function (xhr) {
//           const msg = (xhr.responseJSON && xhr.responseJSON.error) ||
//             'Could not fetch tracking. Please check the number and try again.';
//           $result.addClass('error').html(banner('error', msg));
//           console.error('[Track order] failed', xhr.status, xhr.responseJSON || xhr.responseText);
//         })
//         .always(function () {
//           $submit.prop('disabled', false).text(submitText);
//         });
//     });
// })(jQuery);
(function ($) {
  'use strict';

  const NS = '.trackOrder';
  // const ENDPOINT = 'https://joyun-trackorder.sagar-shopify.workers.dev';
  const ENDPOINT = 'https://joyun-track-order.chintan-chovatiya.workers.dev';

  const esc = s => $('<div>').text(s == null ? '' : s).html();

  // "2026-08-11 16:50:44" -> Date (the "T" makes it parse in Safari too)
  const toDate = str => (str ? new Date(String(str).replace(' ', 'T')) : null);

  const fmtTime = str => {
    const d = toDate(str);
    return d && !isNaN(d) ? d.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' }) : (str || '');
  };

  const fmtDay = str => {
    const d = toDate(str);
    return d && !isNaN(d)
      ? d.toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })
      : (str || '');
  };

  // "Delivered - Delivered to consignee - Code Verified delivery"
  // -> headline: "Delivered", detail: "Delivered to consignee - Code Verified delivery"
  const splitStatus = str => {
    const [headline, ...rest] = String(str || '').split(' - ');
    return { headline, detail: rest.join(' - ') };
  };

  const banner = (type, msg) =>
    `<div class="order-tracker__banner banner banner--${type}"><p class="banner__content">${esc(msg)}</p></div>`;

  const processingBlock = () => `
    <div class="order-tracker__processing">
      <h2 class="order-tracker__processing-title heading h4">Your Order Is Under Processing</h2>
      <div class="order-tracker__processing-text">We will update the Estimated Delivery Date once the order is processed.</div>
    </div>`;

  function render(data) {
    const activities = data.activities || [];
    const latest = activities[0] || {};
    const isDelivered = String(data.status || '').toLowerCase() === 'delivered';

    // Group scans by day (API already returns newest first)
    const groups = [];
    const byDay = {};
    activities.forEach(a => {
      const day = fmtDay(a.date);
      if (!byDay[day]) {
        byDay[day] = { day, items: [] };
        groups.push(byDay[day]);
      }
      byDay[day].items.push(a);
    });

    const timeline = groups.map(group => {
      const items = group.items.map(a => {
        const { headline, detail } = splitStatus(a.status);
        return `
          <li class="order-tracker__scan">
            <div class="order-tracker__scan--wrapper">
              <span class="order-tracker__scan-time">${esc(fmtTime(a.date))}</span>
              <span class="order-tracker__scan-headline">${esc(headline)}</span>
              ${detail ? `<span class="order-tracker__scan-detail">${esc(detail)}</span>` : ''}
              ${a.location ? `<span class="order-tracker__scan-sub">${esc(a.location)}</span>` : ''}
            </div>
          </li>`;
      }).join('');

      return `
        <div class="order-tracker__day-group">
          <p class="order-tracker__day">${esc(group.day)}</p>
          <ul class="order-tracker__timeline">${items}</ul>
        </div>`;
    }).join('');

    const emptyNote = data.awb
      ? 'Tracking updates will appear once the courier scans your package.'
      : 'Your order is being prepared for dispatch.';

    return `
      <div class="order-tracker__summary">
        <p class="order-tracker__status-label text--small">Order ${esc(data.order_id)} · Current status</p>
        <p class="order-tracker__status heading h5">${esc(data.status)}</p>
        ${latest.status ? `<p class="order-tracker__summary-line">${esc(splitStatus(latest.status).detail || latest.status)}</p>` : ''}
        ${latest.location ? `<p class="order-tracker__summary-line"><span class="order-tracker__summary-line-label">Location:</span> ${esc(latest.location)}</p>` : ''}
        ${data.courier ? `<p class="order-tracker__summary-line"><span class="order-tracker__summary-line-label">Courier:</span> ${esc(data.courier)}${data.awb ? ` · AWB ${esc(data.awb)}` : ''}</p>` : ''}
        ${isDelivered && latest.date
          ? `<p class="order-tracker__edd"><span class="order-tracker__summary-line-label">Delivered on:</span> ${esc(fmtDay(latest.date))}</p>`
          : data.etd ? `<p class="order-tracker__edd"><span class="order-tracker__summary-line-label">Expected delivery:</span> ${esc(fmtDay(data.etd))}</p>` : ''}
        ${!activities.length ? `<p class="order-tracker__summary-line">${esc(emptyNote)}</p>` : ''}
      </div>
      ${timeline ? `<div class="order-tracker__timeline-wrap">${timeline}</div>` : ''}`;
  }

  $(document)
    .off(NS)
    .on('submit' + NS, '[data-track-form]', function (e) {
      e.preventDefault();

      const $form = $(this);
      const $root = $form.closest('[data-track-order]');
      const $result = $root.find('[data-track-result]');
      const $submit = $form.find('[type="submit"]');
      const submitText = $submit.data('text') || $submit.text();
      const orderId = $.trim($form.find('[name="order_id"]').val()).replace(/^#/, '');

      $submit.data('text', submitText);
      $result.removeClass('error').empty();

      if (!orderId) {
        $result.addClass('error').html(banner('error', 'Please enter your order number.'));
        return;
      }

      $submit.prop('disabled', true).text('Tracking…');

      $.ajax({
        url: ENDPOINT,
        method: 'POST',
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify({ order_id: orderId })
      })
        .done(function (data) {
          $result.html(render(data));
        })
        .fail(function (xhr) {
          $result.addClass('error').html(processingBlock());
          console.error('[Track order] failed', xhr.status, xhr.responseJSON || xhr.responseText);
        })
        .always(function () {
          $submit.prop('disabled', false).text(submitText);
          $('html, body').animate({ scrollTop: $result.offset().top - 90 }, 400);
        });
    });
})(jQuery);

// =========================================================
(() => {
  const ENDPOINT = 'https://edd-joyun.chintan-chovatiya.workers.dev/';

  const formatDate = (value) => {
    // Parse YYYY-MM-DD manually to avoid timezone shifts; fall back to native parsing
    const m = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
    const date = m ? new Date(m[1], m[2] - 1, m[3]) : new Date(value);
    if (isNaN(date)) return value;

    const part = (opts) => date.toLocaleDateString('en-GB', opts);
    // return `${part({ weekday: 'long' })}, ${date.getDate()} ${part({ month: 'long' })} ${date.getFullYear()}`;
    return `${date.getDate()} ${part({ month: 'long' })} ${date.getFullYear()}`;
  };

  const check = async (checker) => {
    const input = checker.querySelector('#pincode-input');
    const button = checker.querySelector('.pincode-checker__submit');
    const result = checker.querySelector('.pincode-checker__result');
    const pincode = input.value.trim();

    if (pincode.length !== 6 || button.disabled) return;

    const show = (type, message) => {
      result.classList.remove('error', 'success');
      result.classList.add(type);
      result.innerHTML = message;
    };

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    result.classList.remove('error', 'success');
    result.innerHTML = '';

    try {
      const res = await fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pincode })
      });
      const data = await res.json();

      if (!res.ok) throw new Error(data.detail || data.error);

      if (data.serviceable) {
        show('success', `Estimated delivery by <strong>${formatDate(data.etd)}</strong>`);
      } else {
        show('error', `Delivery not available for this pincode ${pincode}`);
      }
    } catch (err) {
      console.log(err);
      show('error', 'Unable to check right now. Please try again.');
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  };

  // Digits only, enable button at 6 digits
  document.addEventListener('input', (e) => {
    if (!e.target.matches('.pincode-checker #pincode-input')) return;

    const input = e.target;
    input.value = input.value.replace(/\D/g, '').slice(0, 6);
    input.closest('.pincode-checker').querySelector('.pincode-checker__submit').disabled = input.value.length !== 6;
  });

  // Button click
  document.addEventListener('click', (e) => {
    const button = e.target.closest('.pincode-checker__submit');
    if (button) check(button.closest('.pincode-checker'));
  });

  // Enter key (stops form from reloading the page)
  document.addEventListener('submit', (e) => {
    if (!e.target.matches('.pincode-checker__row')) return;
    e.preventDefault();
    check(e.target.closest('.pincode-checker'));
  });
})();